<div *ngIf="productsList">
  <ul class="product-cards-container">
    <li class="product-cards" *ngFor="let product of productsList">
      <app-all-products-card [productDetails]="product?.productDetails"></app-all-products-card>
    </li>
  </ul>
</div>
